import { ConnectProto } from "@racoon/api";
import { useT } from "@racoon/i18n";
import { EMPTY_CELL } from "@racoon/lib";
import { incidentNoteLabel, jobIncidentNote } from "~/shared/lib/job-incident";
import { IncidentChip } from "~/shared/ui/incident-chip";

type Props = {
  job: ConnectProto.Job;
  /** The incidents of the jobs listed with it (one request per order); undefined until they arrive. */
  incidents?: readonly ConnectProto.DriverIncident[];
};

/**
 * Why a job was not carried out (see `jobIncidentNote`): the incident recorded on it,
 * the one its shift was force-completed with, or debt.
 */
export const JobIncident = ({ job, incidents }: Props) => {
  const t = useT();
  // Until the incidents arrive, whether the job has one is unknown.
  if (!incidents) return null;
  const note = jobIncidentNote(job, incidents);
  if (!note) return null;
  return (
    <IncidentChip tone={note.kind} title={note.explanation}>
      {incidentNoteLabel(t, note) ?? EMPTY_CELL}
    </IncidentChip>
  );
};
